document.addEventListener("DOMContentLoaded", function () {
  if (
    window.location.pathname.includes("/collections/commercial-air-cleaners")
  ) {
    document
      .querySelectorAll(".price__container")
      .forEach(function (priceContainer) {
        priceContainer.style.display = "none";
      });
  }
});
document.addEventListener("DOMContentLoaded", function () {
  if (window.location.pathname.includes("/collections/molecular-filters")) {
    document
      .querySelectorAll(".price__container")
      .forEach(function (priceContainer) {
        priceContainer.style.display = "none";
      });
  }
});

// This code is for min max it is not working beacuse product will automatically added in cart
// document.addEventListener("DOMContentLoaded", function () {
//   console.log("JavaScript Loaded");

//   // Monitor the Add to Cart button click
//   document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
//     console.log("Found Add to Cart Form");

//     form.addEventListener("submit", function (event) {
//       const productIdInput = form.querySelector('input[name="id"]');
//       const quantityInput = form.querySelector('input[name="quantity"]');

//       const productId = productIdInput ? productIdInput.value : null;
//       const quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;

//       console.log("Product ID:", productId);
//       console.log("Quantity:", quantity);

//       // Apply restriction to the specific product ID
//       const variantId = "50301675110701"; // Replace with your variant ID
//       if (productId === variantId && quantity < 5) {
//         console.log("Preventing Add to Cart. Quantity too low:", quantity);

//         // Delay execution to ensure no other scripts interfere
//         setTimeout(function() {
//           console.log("Event triggered - Preventing form submission.");
//           event.preventDefault(); // Prevent form submission
//           event.stopPropagation(); // Stop event propagation

//           // Display an alert to the user
//           alert("You must order at least 5 masks.");
//         }, 0);

//         return false; // Explicitly return false to prevent submission
//       } else {
//         console.log("Form Submitted Successfully");
//       }
//     });
//   });
// });



